/*
 *
 *   reducer
 *
 */
import { produce } from "immer";

import {
  LOAD_PACKAGES_LIST_SUCCESS,
  LOAD_PACKAGES_LIST_ERROR,
  LOAD_DESTINATION_SEARCH_LIST_SUCCESS,
  LOAD_DESTINATION_SEARCH_LIST_ERROR,
  LOAD_PACKAGES_TOTAL_LIST_SUCCESS,
  LOAD_PACKAGES_TOTAL_LIST_ERROR,
  LOAD_PACKAGES_SINGLE_LIST_SUCCESS,
  LOAD_PACKAGES_SINGLE_LIST_ERROR,
  LOAD_TERMS_AND_CONDITIONS_LIST_SUCCESS,
  LOAD_TERMS_AND_CONDITIONS_LIST_ERROR,
  LOAD_TERMS_SINGLE_CONDITIONS_LIST_SUCCESS,
  LOAD_TERMS_SINGLE_CONDITIONS_LIST_ERROR,
  LOAD_PACKAGES_FAQ_LIST_SUCCESS,
  LOAD_PACKAGES_FAQ_LIST_ERROR,
  LOAD_PACKAGES_FAQ_MAIN_LIST_SUCCESS,
  LOAD_PACKAGES_FAQ_MAIN_LIST_ERROR,
  LOAD_TRAVELLER_AGE_RESTRICTIONS_SUCCESS,
  LOAD_TRAVELLER_AGE_RESTRICTIONS_ERROR,
  LOAD_PACKAGES_LIST_RECORDS_META_DATA_SUCCESS,
  LOAD_PACKAGES_LIST_RECORDS_META_DATA_ERROR,
} from "./constants";

const initialState = {
  packages_list: [],
  destination_search_list: [],
  packages_total_list: [],
  packages_single_list: [],
  terms_conditions: [],
  terms_single_conditions_list: [],
  packages_faq_list: [],
  packages_faq_main_list: [],
  traveller_age_restrictions: [],
  recordsMetaData: {},
  loading: false,
  error: false,
  success: false,
  lastUpdate: null,
};

const Reducer = (
  state = initialState,
  {
    type,
    packages_single_list,
    terms_conditions,
    terms_single_conditions_list,
    packages_faq_list,
    packages_faq_main_list,
    traveller_age_restrictions,
    packages_list,
    destination_search_list,
    packages_total_list,
    recordsMetaData = {},
    error,
    success,
  }
) => {
  return produce(state, (draft) => {
    switch (type) {
      // case LOAD_RECORDS_VALID_CACHE:
      //   draft.loading = false;
      //   draft.error = false;
      //   draft.success = false;
      //   break;
      case LOAD_TERMS_AND_CONDITIONS_LIST_SUCCESS:
        draft.terms_conditions = terms_conditions;
        draft.loading = false;
        draft.error = false;
        draft.success = false;
        break;
      case LOAD_PACKAGES_FAQ_LIST_SUCCESS:
        draft.packages_faq_list = packages_faq_list;
        draft.loading = false;
        draft.error = false;
        draft.success = false;
        break;
      case LOAD_PACKAGES_FAQ_MAIN_LIST_SUCCESS:
        draft.packages_faq_main_list = packages_faq_main_list;
        draft.loading = false;
        draft.error = false;
        draft.success = false;
        break;
      case LOAD_TRAVELLER_AGE_RESTRICTIONS_SUCCESS:
        draft.traveller_age_restrictions = traveller_age_restrictions;
        draft.loading = false;
        draft.error = false;
        draft.success = false;
        break;
      case LOAD_TERMS_SINGLE_CONDITIONS_LIST_SUCCESS:
        draft.terms_single_conditions_list = terms_single_conditions_list;
        draft.loading = false;
        draft.error = false;
        draft.success = false;
        break;
      case LOAD_PACKAGES_LIST_SUCCESS:
        draft.packages_list = packages_list;
        draft.loading = false;
        draft.error = false;
        draft.success = false;
        break;
      case LOAD_DESTINATION_SEARCH_LIST_SUCCESS:
        draft.destination_search_list = destination_search_list;
        draft.loading = false;
        draft.error = false;
        draft.success = false;
        break;
      case LOAD_PACKAGES_TOTAL_LIST_SUCCESS:
        draft.packages_total_list = packages_total_list;
        draft.loading = false;
        draft.error = false;
        draft.success = false;
        break;
      case LOAD_PACKAGES_SINGLE_LIST_SUCCESS:
        draft.packages_single_list = packages_single_list;
        draft.loading = false;
        draft.error = false;
        draft.success = false;
        break;

      case LOAD_PACKAGES_LIST_RECORDS_META_DATA_SUCCESS:
        draft.recordsMetaData = recordsMetaData;
        draft.error = false;
        draft.success = success;
        break;

      case LOAD_PACKAGES_LIST_ERROR:
      case LOAD_DESTINATION_SEARCH_LIST_ERROR:
      case LOAD_PACKAGES_SINGLE_LIST_ERROR:
      case LOAD_TERMS_AND_CONDITIONS_LIST_ERROR:
      case LOAD_TERMS_SINGLE_CONDITIONS_LIST_ERROR:
      case LOAD_PACKAGES_FAQ_LIST_ERROR:
      case LOAD_PACKAGES_FAQ_MAIN_LIST_ERROR:
      case LOAD_TRAVELLER_AGE_RESTRICTIONS_ERROR:
      case LOAD_PACKAGES_TOTAL_LIST_ERROR:
        draft.loading = false;
        draft.error = error;
        draft.success = false;
        break;

      case LOAD_PACKAGES_LIST_RECORDS_META_DATA_ERROR:
        draft.error = error;
        draft.success = false;
        break;
      default:
        return state;
    }
  });
};

export default Reducer;
